import { useState } from "react"

export default function useOptions<TData>(
  data?: TData[],
  key: string = "name"
) {
  const [search, setSearch] = useState<string>("")

  const options = !search
    ? data
    : data?.filter((emp: any) =>
      emp[key].toLowerCase().includes(search.toLocaleLowerCase())
    )

  return { search, setSearch, options }
}
